/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type UserResponseDocumentTheme = typeof UserResponseDocumentTheme[keyof typeof UserResponseDocumentTheme];


export const UserResponseDocumentTheme = {
  dark: 'dark',
  light: 'light',
} as const;
